<template>
  <form @submit.prevent validate>
    <CModal
        :title.sync="title"
        color="info"
        size="lg"
        :closeOnBackdrop ="false"
        :show.sync="show"
        >
        <CRow>
          <CCol>
             <label > Usher Team </label>
             <CRow >
              <CCol >
                <multiselect v-model="form.usher_name" placeholder="Select Usher Name" :custom-label="usherName" :options="options_usher" label="text" track-by="text" ></multiselect>
              </CCol>
               
              <CCol >
                <multiselect v-model="form.tl_usher_name" placeholder="Select TL Usher Name" :custom-label="usherName" :options="options_tl_usher" label="text" track-by="text"   ></multiselect>
                
              </CCol>
            </CRow>
            <CRow class="mt-2">
            <CCol>
            <label>Service ID</label>
            </CCol>
             <CCol>
            <strong> </strong>
            </CCol>
             <CCol>
            <label>Service Date</label>
            </CCol>
             <CCol>
            <strong> </strong>
            </CCol>
            </CRow>
            <CRow >
              
              <CCol >
                <b-form-select v-model="form.service_id" :options="options"></b-form-select>
              </CCol>
              <CCol >
                <CInput
                v-model="form.service_date"
                type="date"
            />
              </CCol>
            </CRow>
            <hr>

            <div class="text-center">
            <small class="text-center"> <b>SANCTUARY LEVEL 3 & LEVEL 4 </b> </small>
            </div>
            <CRow class="mt-4 ">
            <CCol>
            <strong>COLUMN 1</strong>
            </CCol>
             <CCol>
            <strong>COLUMN 2</strong>
            </CCol>
             <CCol>
            <strong>COLUMN 3</strong>
            </CCol>
             <CCol>
            <strong>BALCONY</strong>
            </CCol>
            </CRow>
            <CRow  >
              <CCol v-on:keyup="key_up_main_service_column_1">
                <small>Orang Dewasa</small>
                <CInput v-model="form.attendance.main_service.column_1.adults"  placeholder='Orang Dewasa' type="number" class="mb-1" /> 
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.main_service.column_1.kids" placeholder='Anak Kecil' type="number" class="mb-1" /> 
                <small>Sound Table</small>
                <CInput v-model="form.attendance.main_service.column_1.sound_table" placeholder='Sound Table' type="number" class="mb-1" /> 
                <small>Ushers</small>
                <CInput v-model="form.attendance.main_service.column_1.ushers" placeholder='Ushers' type="number" class="mb-1" /> 
                <small>Praise & Worship</small>
                <CInput v-model="form.attendance.main_service.column_1.pw" placeholder='PW' type="number" class="mb-1" /> 
                <small>Total</small>
                <CInput v-model="form.attendance.main_service.column_1.total" placeholder='Total' class="mb-1" readonly/> 
              </CCol>
              <CCol v-on:keyup="key_up_main_service_column_2">
                <small>Orang Dewasa</small>
                <CInput v-model="form.attendance.main_service.column_2.adults"  placeholder='Orang Dewasa' type="number" class="mb-1" /> 
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.main_service.column_2.kids" placeholder='Anak Kecil' type="number" class="mb-1" /> 
                <CInput v-model="form.attendance.main_service.column_2.total" placeholder='Total' class="mb-1" readonly/> 
                
              </CCol>
              
              <CCol v-on:keyup="key_up_main_service_column_3">
                <small>Orang Dewasa</small>
                <CInput v-model="form.attendance.main_service.column_3.adults"  placeholder='Orang Dewasa' type="number" class="mb-1" /> 
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.main_service.column_3.kids" placeholder='Anak Kecil' type="number" class="mb-1" /> 
                <CInput v-model="form.attendance.main_service.column_3.total" placeholder='Total' class="mb-1" readonly/> 
              </CCol>
              <CCol v-on:keyup="key_up_main_service_balcony">
                <small>Orang Dewasa</small>
                <CInput v-model="form.attendance.main_service.balcony.adults"  placeholder='Orang Dewasa' type="number" class="mb-1" /> 
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.main_service.balcony.kids" placeholder='Anak Kecil' type="number" class="mb-1" /> 
                  <CRow class="mt-2 ">
            <CCol>
            <strong>BABY ROOM (NO NANNY)</strong>
            </CCol>
            </CRow>
            <CRow>
           <CCol  v-on:keyup="key_up_main_service_baby_room">
             
               <small>Orang Dewasa</small>
                <CInput v-model="form.attendance.main_service.baby_room.adults" placeholder='Orang Dewasa' type="number" class="mb-1" /> 
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.main_service.baby_room.kids" placeholder='Anak Kecil' type="number"  /> 
              </CCol>
            </CRow>
            <small class="mt-2"> Total </small>
                <CInput  v-model="form.attendance.main_service.balcony.total"  placeholder='Total'  readonly/> 
              </CCol>
              
            </CRow>
          
           <CInput v-model="form.attendance.main_service.total" placeholder='Level 3 & 4 Total' class="text-center" center readonly/>
            <hr>
           <div class="text-center">
            <small class="text-center"> <b>iKIDS Level 2 </b> </small>
            </div>
            <CRow class="mt-4 ">
            <CCol>
            <strong>PRECIOUS</strong>
            </CCol>
             <CCol>
            <strong>MIGHTY</strong>
            </CCol>
             <CCol>
            <strong>AWESOME</strong>
            </CCol>
             <CCol>
            <strong>SUPER</strong>
            </CCol>
            </CRow>
            <CRow v-on:keyup="key_up_level_2">
              <CCol >
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.level_2.Precious" placeholder='Anak kecil' type="number" class="mb-2" /> 
              </CCol>
              <CCol >
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.level_2.Mighty"  placeholder='Anak kecil' type="number" class="mb-2" /> 
              </CCol>
              <CCol >
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.level_2.Awesome"  placeholder='Anak kecil' type="number" class="mb-2" /> 
              </CCol>
              <CCol >
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.level_2.Super"  placeholder='Anak kecil' type="number" class="mb-2" />
              </CCol>
            </CRow>
            <CRow class="mt-2 ">
            <CCol>
            <strong>WONDER</strong>
            </CCol>
             <CCol>
            <strong>INCREDIBLE</strong>
            </CCol>
             <CCol>
            <strong>NEWCOMER</strong>
            </CCol>
             <CCol>
            <strong>PENDAMPING</strong>
            </CCol>
            </CRow>
             <CRow v-on:keyup="key_up_level_2">
              <CCol >
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.level_2.Wonder" type="number" placeholder='Anak kecil'/> 
                
              </CCol>
              <CCol >
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.level_2.Incredible"  placeholder='Anak kecil' type="number" /> 
              </CCol>
              <CCol >
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.level_2.Newcomer"  placeholder='Anak kecil' type="number"  />  
              </CCol>
              <CCol >
                <small>Orang Dewasa</small> 
                <CInput v-model="form.attendance.level_2.adults"  placeholder='Orang Dewasa'  type="number" /> 
                <small>Nanny</small>
                <CInput v-model="form.attendance.level_2.nanny"  placeholder='Nanny' type="number"  /> 
              </CCol>
            </CRow>
           <CInput v-model="form.attendance.level_2.total" class="text-center" readonly center placeholder='Level 2 Total' /> 
           <hr> 
           <div class="text-center">
             <p> <small class="text-center"> <b> ECHO ROOM LEVEL 1 </b> </small> </p>
            <small class="text-center"> <b>YOUTH </b> </small>
            </div>
           
            <CRow class="mt-2 ">
            <CCol>
            <strong>YOUTH</strong>
            </CCol>
             <CCol>
            <strong>PENGAJAR + ASSISTANT</strong>
            </CCol>
             <CCol>
            <strong> </strong>
            </CCol>
             
            </CRow>
            <CRow  v-on:keyup="key_up_level_1">
              <CCol >
                <small>Anak Muda</small>
                <CInput v-model="form.attendance.youth.youth"  placeholder='Anak Muda'  type="number" class="mb-3" />  
              </CCol>
              <CCol >
                <small>Orang Dewasa</small>
                <CInput v-model="form.attendance.youth.teachers"  placeholder='Orang Dewasa' type="number" class="mb-3" />  </CCol>
                 
              <CCol >
                <small>Total</small>
                <CInput v-model="form.attendance.youth.total"  readonly placeholder='Total ' class="mb-3" />  
              </CCol>
            </CRow>
            <div class="text-center mt-2">
            <small class="text-center">  <b> PLAYGROUND </b> </small>
            
            </div>
            
            <CRow class="mt-2">
            <CCol>
            <strong>IKIDS</strong>
            </CCol>
             <CCol>
            <strong>PENDAMPING</strong>
            </CCol>
             <CCol>
            <strong> </strong>
            </CCol>
            </CRow>
            <CRow  v-on:keyup="key_up_level_1">
              <CCol >
                <small>Anak Kecil</small>
                <CInput v-model="form.attendance.playground.adults"  placeholder='Anak Kecil' type="number" class="mb-3" />  
              </CCol>
              <CCol >
                <small>Oranga Dewasa</small>
                <CInput v-model="form.attendance.playground.kids"  placeholder='Orang Dewasa' type="number" class="mb-3" />  </CCol>
                 
              <CCol >
                <small>Total</small>
                <CInput v-model="form.attendance.playground.total"  readonly placeholder='Total ' type="number" class="mb-3" />  
              </CCol>
            </CRow>
           <CInput v-model="form.attendance.level_1.total" class="mb-3" readonly center placeholder='Level 1 Total' />  
           <hr>
           <CInput v-model="form.total" class="text-center" description="Total Level 1+2+3+4" readonly center placeholder='Grand Total' />  
          </CCol> 
          </CRow>
          <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)" color="info">Edit</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>

import moment from 'moment';
import EventBus from '@/eventBus';

import service from '@/services/service'
import member from '@/services/member'

import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
name: 'serviceattendancemodal',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      options: [],  
      options_usher: [],
      options_tl_usher: [],
      form:{
        id: '',
        usher_name: '',
        tl_usher_name: '',
        total: '',
        service_id: '',
        service_date: '',
        attendance: {
            main_service: {
                column_1: {
                    adults: '',
                    kids: '',
                    sound_table: '',
                    ushers: '',
                    pw: '',
                    total: ''
                },
                column_2: {
                    adults: '',
                    kids: '',
                    total: ''
                },
                column_3: {
                    adults: '',
                    kids: '',
                    total: ''
                },
                balcony: {
                    adults: '',
                    kids: '',
                    total: ''
                },
                baby_room: {
                    adults: '',
                    kids: ''
                },
                total: ''
            },
            level_2: {
                Precious: '',
                Mighty: '',
                Awesome: '',
                Super: '',
                Newcomer: '',
                Wonder: '',
                Incredible: '',
                adults: '',
                nanny: '',
                total: ''
            },
            youth: {
                youth: '',
                teachers: '',
                total: ''
            },
            playground: {
                adults: '',
                kids: '',
                total: ''
            },
            level_1: {
                total: ''
            }
        },
      },
    }
  },
  mounted(){
      //this.tt = "Heru Setiawan";
  }, 
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_SERVICE', (params) => {
      if(params.data){

        this.getServiceType() //GET SERVICE TYPE ALL FOR DROPDOWNLIST
        this.getMemberName()

        

        service.getServiceAttendancebyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = res.data.id;
          self.form.usher_name = { "text": res.data.usher_name };
          self.form.tl_usher_name = { "text": res.data.tl_usher_name };
          self.form.total = res.data.total;
          self.form.service_id = res.data.service_id;
          self.form.service_date = res.data.service_date

          for (var t in self.form.attendance.main_service.column_1) {
            self.form.attendance.main_service.column_1[t] = res.data.attendance_details.main_service.column_1[t] != null ? res.data.attendance_details.main_service.column_1[t] : '';
          }
          for (var t in self.form.attendance.main_service.column_2) {
            self.form.attendance.main_service.column_2[t] = res.data.attendance_details.main_service.column_2[t] != null ? res.data.attendance_details.main_service.column_2[t] : '';
          }
          for (var t in self.form.attendance.main_service.column_3) {
            self.form.attendance.main_service.column_3[t] = res.data.attendance_details.main_service.column_3[t] != null ? res.data.attendance_details.main_service.column_3[t] : '';
          }
          for (var t in self.form.attendance.main_service.balcony) {
            self.form.attendance.main_service.balcony[t] = res.data.attendance_details.main_service.balcony[t] != null ? res.data.attendance_details.main_service.balcony[t] : '';
          }
          for (var t in self.form.attendance.main_service.baby_room) {
            self.form.attendance.main_service.baby_room[t] = res.data.attendance_details.main_service.baby_room[t] != null ? res.data.attendance_details.main_service.baby_room[t] : '';
          }
          self.form.attendance.main_service.total = res.data.attendance_details.main_service.total != null ? res.data.attendance_details.main_service.total : '';

          for (var t in self.form.attendance.level_2) {
            self.form.attendance.level_2[t] = res.data.attendance_details.level_2[t] != null ? res.data.attendance_details.level_2[t] : '';
          }
          for (var t in self.form.attendance.youth) {
            self.form.attendance.youth[t] = res.data.attendance_details.youth[t] != null ? res.data.attendance_details.youth[t] : '';
          }
          for (var t in self.form.attendance.playground) {
            self.form.attendance.playground[t] = res.data.attendance_details.playground[t] != null ? res.data.attendance_details.playground[t] : '';
          }
          for (var t in self.form.attendance.level_1) {
            self.form.attendance.level_1[t] = res.data.attendance_details.level_1[t] != null ? res.data.attendance_details.level_1[t] : '';
          }

        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{

        this.getServiceTypeOnlyActive() //GET SERVICE TYPE ONLY ACTIVE FOR DROPDOWNLIST
        this.getMemberName()

        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.usher_name = ""
        self.form.tl_usher_name = "";
        self.form.total = "";
        self.form.service_id = "";
        self.form.service_date = "";

        Object.keys(self.form.attendance.main_service.column_1).forEach(function(key,index) {self.form.attendance.main_service.column_1[key] = '';});
        Object.keys(self.form.attendance.main_service.column_2).forEach(function(key,index) {self.form.attendance.main_service.column_2[key] = '';});
        Object.keys(self.form.attendance.main_service.column_3).forEach(function(key,index) {self.form.attendance.main_service.column_3[key] = '';});
        Object.keys(self.form.attendance.main_service.balcony).forEach(function(key,index) {self.form.attendance.main_service.balcony[key] = '';});
        Object.keys(self.form.attendance.main_service.baby_room).forEach(function(key,index) {self.form.attendance.main_service.baby_room[key] = '';});
        self.form.attendance.main_service.total = '';
        Object.keys(self.form.attendance.level_2).forEach(function(key,index) {self.form.attendance.level_2[key] = '';});
        Object.keys(self.form.attendance.youth).forEach(function(key,index) {self.form.attendance.youth[key] = '';});
        Object.keys(self.form.attendance.playground).forEach(function(key,index) {self.form.attendance.playground[key] = '';});
        Object.keys(self.form.attendance.level_1).forEach(function(key,index) {self.form.attendance.level_1[key] = '';});

      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      this.form.service_date  = moment(this.form.service_date).format ('DD/MM/YYYY')
      this.form.usher_name = this.form.usher_name.text
      this.form.tl_usher_name = this.form.tl_usher_name.text
      service.createServiceAttendance(this.form)
      .then(res => {
       
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
          this.show = false;
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
        
    },
    update(id){
      this.form.service_date  = moment(this.form.service_date).format ('DD/MM/YYYY')
      this.form.usher_name = this.form.usher_name.text
      this.form.tl_usher_name = this.form.tl_usher_name.text
      service.updateServiceAttendance(id, this.form)
      .then(res => {
        this.show = false;
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    //GET MEMBER NAME DROPDOWNLIST
    getMemberName(){
      this.options_usher = []
      this.options_tl_usher = []
      member.getMember()
      .then(res => {
        console.log(res.data.member)
        for (let i=0; i <= res.data.member.length-1; i++){
          this.options_usher.push({text: res.data.member[i].name, value:res.data.member[i].uuid})
          this.options_tl_usher.push({text: res.data.member[i].name, value:res.data.member[i].uuid})
          // this.options_usher.push({text: res.data.member[i].name})
          // this.options_tl_usher.push({text: res.data.member[i].name})
        }
      }).catch((er) =>{
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    //GET SERVICE TYPE ALL FOR DROPDOWNLIST
    getServiceType(){
      this.options = []
      service.getServiceType()
      .then(res => {
        for(let i = 0; i <= res.data.length-1; i++){
          this.options.push({text: res.data[i].name, value: res.data[i].id});
        }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })   
    },
    //GET SERVICE TYPE ONLY ACTIVE FOR DROPDOWNLIST
    getServiceTypeOnlyActive(){
      this.options = []
      service.getServiceTypeOnlyActive()
      .then(res => {
        for(let i = 0; i <= res.data.length-1; i++){
          this.options.push({text: res.data[i].name, value: res.data[i].id});
        }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    //KEY UP FUNCTION START // FOR CALCULATE TOTAL
    key_up_main_service_column_1: function(event) {
        this.form.attendance.main_service.column_1.total = 0
        Object.values(this.form.attendance.main_service.column_1).forEach(value => {
            this.form.attendance.main_service.column_1.total += value != '' ? parseInt(value) : 0
        });
        this.total_main_service();
    },
    key_up_main_service_column_2: function(event) {
        this.form.attendance.main_service.column_2.total = 0
        Object.values(this.form.attendance.main_service.column_2).forEach(value => {
            this.form.attendance.main_service.column_2.total += value != '' ? parseInt(value) : 0
        });
        this.total_main_service();
    },
    key_up_main_service_column_3: function(event) {
        this.form.attendance.main_service.column_3.total = 0
        Object.values(this.form.attendance.main_service.column_3).forEach(value => {
            this.form.attendance.main_service.column_3.total += value != '' ? parseInt(value) : 0
        });
        this.total_main_service();
    },
    key_up_main_service_balcony: function(event) {
        this.form.attendance.main_service.balcony.total = 0
        Object.values(this.form.attendance.main_service.balcony).forEach(value => {
            this.form.attendance.main_service.balcony.total += value != '' ? parseInt(value) : 0
        });
        Object.values(this.form.attendance.main_service.baby_room).forEach(value => {
            this.form.attendance.main_service.balcony.total += value != '' ? parseInt(value) : 0
        });
        this.total_main_service();
    },
    key_up_main_service_baby_room: function(event) {
        this.form.attendance.main_service.balcony.total = 0
        Object.values(this.form.attendance.main_service.balcony).forEach(value => {
            this.form.attendance.main_service.balcony.total += value != '' ? parseInt(value) : 0
        });
        Object.values(this.form.attendance.main_service.baby_room).forEach(value => {
            this.form.attendance.main_service.balcony.total += value != '' ? parseInt(value) : 0
        });
        this.total_main_service();
    },
    total_main_service() {
      var column_1 = this.form.attendance.main_service.column_1.total != '' ? parseInt(this.form.attendance.main_service.column_1.total) : 0
      var column_2 = this.form.attendance.main_service.column_2.total != '' ? parseInt(this.form.attendance.main_service.column_2.total) : 0
      var column_3 = this.form.attendance.main_service.column_3.total != '' ? parseInt(this.form.attendance.main_service.column_3.total) : 0
      var balcony = this.form.attendance.main_service.balcony.total != '' ? parseInt(this.form.attendance.main_service.balcony.total) : 0
      this.form.attendance.main_service.total = column_1 + column_2 + column_3 + balcony
      this.grand_total();
    },

    key_up_level_2: function(event) {
        this.form.attendance.level_2.total = 0
        Object.values(this.form.attendance.level_2).forEach(value => {
            this.form.attendance.level_2.total += value != '' ? parseInt(value) : 0
        });
        this.grand_total();
    },

    key_up_level_1: function(event) {
        this.form.attendance.youth.total = 0
        this.form.attendance.playground.total = 0
        this.form.attendance.level_1.total = 0
        Object.values(this.form.attendance.youth).forEach(value => {
            this.form.attendance.youth.total += value != '' ? parseInt(value) : 0
            this.form.attendance.level_1.total += value != '' ? parseInt(value) : 0
        });
        Object.values(this.form.attendance.playground).forEach(value => {
            this.form.attendance.playground.total += value != '' ? parseInt(value) : 0
            this.form.attendance.level_1.total += value != '' ? parseInt(value) : 0
        });
        this.grand_total();
    },

    grand_total() {
      var level34 = this.form.attendance.main_service.total != '' ? parseInt(this.form.attendance.main_service.total) : 0
      var level2 = this.form.attendance.level_2.total != '' ? parseInt(this.form.attendance.level_2.total) : 0
      var level1 = this.form.attendance.level_1.total != '' ? parseInt(this.form.attendance.level_1.total) : 0
      this.form.total = level34 + level2 + level1
    },
    //KEY UP FUNCTION END // FOR CALCULATE TOTAL
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>